export default "__VITE_ASSET___kgL_2G9__"